import { Presentation } from "lucide-react";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export function WelcomePage(){
    const {t} = useTranslation("common");
    return <div className="max-w-2xl flex flex-col items-center justify-center mx-auto">
        <div className="flex items-center justify-start mb-4 w-full">
            <Presentation className="w-14 h-14 mb-4 inline text-orange-500" />
        </div>
        <h1 className="text-4xl font-bold mb-4">{t("tutor-inscription-status.formation.welcome.title")}</h1>
        <p className="mb-4">{t("tutor-inscription-status.formation.welcome.description")}</p>
        <Link to="/formation/1" className="w-full text-white bg-orange-500 hover:bg-orange-500/80 py-3 px-4 rounded-md inline-block text-center">
            {t("tutor-inscription-status.formation.welcome.button")}
        </Link>
    </div>
}
